$(document).ready(function() {
  document.querySelectorAll('.video-placeholder').forEach(item => {
      item.addEventListener('click', function () {
          var videoUrl = this.getAttribute('data-video_url');
          openVideoModal(videoUrl);
      });
  });
  
  function openVideoModal(videoUrl) {
      var modal = document.getElementById('videoModal');
      var iframe = document.getElementById('videoIframe');
      iframe.src = videoUrl + "&autoplay=1&controls=0&showinfo=0&rel=0&modestbranding=1"; 
      modal.style.display = 'flex';
  }
  document.querySelector('.close').addEventListener('click', function () {
    var modal = document.getElementById('videoModal');
    var iframe = document.getElementById('videoIframe');
    iframe.src = "";
    modal.style.display = 'none';
  });
})